export const TimeFormatIdentifiers = {
  Twelve: "Twelve",
  TwentyFour: "TwentyFour"
};

export const TimeFormatNames = {
  Twelve: "12 hour (3:00pm)",
  TwentyFour: "24 hour (15:00)"
};

const createTimeFormat = id => {
  return {
    identifier: id,
    name: TimeFormatNames[id]
  };
};

export default [createTimeFormat(TimeFormatIdentifiers.Twelve), createTimeFormat(TimeFormatIdentifiers.TwentyFour)];
